"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Head = void 0;

var _button = _interopRequireDefault(require("@clayui/button"));

var _form = require("@clayui/form");

var _icon = _interopRequireDefault(require("@clayui/icon"));

var _layout = _interopRequireDefault(require("@clayui/layout"));

var _react = _interopRequireWildcard(require("react"));

var _collection = require("../collection");

var _dropDown = require("../drop-down");

var _Cell = require("./Cell");

var _ScopeContext = require("./ScopeContext");

var _context = require("./context");

var _excluded = ["children", "items"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Header = /*#__PURE__*/_react.default.forwardRef(function HeaderInner(_ref, ref) {
  var description = _ref.description,
      name = _ref.name;
  return /*#__PURE__*/_react.default.createElement("li", {
    key: name,
    ref: ref,
    role: "presentation",
    tabIndex: -1
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-subheader mb-0"
  }, name.toUpperCase()), /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-section py-0 text-secondary"
  }, description), /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-divider"
  }));
});

function HeadInner(_ref2, ref) {
  var children = _ref2.children,
      items = _ref2.items,
      otherProps = _objectWithoutProperties(_ref2, _excluded);

  var _useTable = (0, _context.useTable)(),
      columnsVisibility = _useTable.columnsVisibility,
      messages = _useTable.messages,
      onHeadCellsChange = _useTable.onHeadCellsChange,
      onVisibleColumnsChange = _useTable.onVisibleColumnsChange,
      visibleColumns = _useTable.visibleColumns;

  var collection = (0, _collection.useCollection)({
    children: children,
    items: items,
    suppressTextValueWarning: false,
    visibleKeys: new Set(visibleColumns.keys())
  });
  (0, _react.useMemo)(function () {
    if (visibleColumns.size === 0) {
      onVisibleColumnsChange(collection.getItems(), 0);
    }

    onHeadCellsChange(collection.getSize());
  }, []);
  return /*#__PURE__*/_react.default.createElement("thead", _extends({}, otherProps, {
    ref: ref
  }), /*#__PURE__*/_react.default.createElement(_ScopeContext.ScopeContext.Provider, {
    value: _ScopeContext.Scope.Head
  }, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement(_collection.Collection, {
    collection: collection
  }), columnsVisibility && /*#__PURE__*/_react.default.createElement(_Cell.Cell, {
    keyValue: "visibility",
    width: "72px"
  }, /*#__PURE__*/_react.default.createElement(_dropDown.Menu, {
    UNSAFE_focusableElements: ['input[role="switch"]'],
    alwaysClose: false,
    items: [{
      description: messages['columnsVisibilityDescription'],
      name: messages['columnsVisibilityHeader']
    }].concat(_toConsumableArray(collection.getItems())),
    style: {
      maxWidth: '210px',
      minWidth: '210px'
    },
    trigger: /*#__PURE__*/_react.default.createElement(_button.default, {
      "aria-label": messages['columnsVisibility'],
      borderless: true,
      displayType: "secondary",
      monospaced: true
    }, /*#__PURE__*/_react.default.createElement(_icon.default, {
      symbol: "caret-bottom"
    }))
  }, function (item) {
    return _typeof(item) === 'object' ? /*#__PURE__*/_react.default.createElement(Header, {
      description: item.description,
      key: item.name,
      name: item.name
    }) : /*#__PURE__*/_react.default.createElement(_dropDown.Item, {
      key: item,
      onClick: function onClick() {
        return onVisibleColumnsChange(item, collection.getItem(item).index);
      },
      tabIndex: -1,
      textValue: collection.getItem(item).value
    }, /*#__PURE__*/_react.default.createElement(_layout.default.ContentRow, {
      verticalAlign: "center"
    }, /*#__PURE__*/_react.default.createElement(_layout.default.ContentCol, {
      expand: true
    }, collection.getItem(item).value), /*#__PURE__*/_react.default.createElement(_layout.default.ContentCol, {
      float: "end"
    }, /*#__PURE__*/_react.default.createElement(_form.ClayToggle, {
      containerProps: {
        style: {
          marginBottom: 0
        }
      },
      disabled: visibleColumns.has(item) && visibleColumns.size === 1,
      onChange: function onChange(event) {
        event.stopPropagation();
        onVisibleColumnsChange(item, collection.getItem(item).index);
      },
      onKeyDown: function onKeyDown(event) {
        switch (event.key) {
          case 'Enter':
            onVisibleColumnsChange(item, collection.getItem(item).index);
            break;

          default:
            break;
        }
      },
      sizing: "sm",
      toggled: visibleColumns.has(item)
    }))));
  })))));
}

var Head = /*#__PURE__*/_react.default.forwardRef(HeadInner);

exports.Head = Head;
Head.displayName = 'TableHead';